interface Props {
  /** 1 = choosing style, 2 = style picked / uploading, 3 = preview. */
  active: 1 | 2 | 3;
}

const STEPS: { num: 1 | 2 | 3; label: string }[] = [
  { num: 1, label: 'Choose style' },
  { num: 2, label: 'Upload' },
  { num: 3, label: 'Preview' },
];

/**
 * StepBar — sticky progress bar at the top of the widget, matching the
 * WooCommerce flow: "1 CHOOSE STYLE › 2 UPLOAD › 3 PREVIEW". Steps up to the
 * active one show a filled gold circle; later steps are dimmed.
 */
export function StepBar({ active }: Props) {
  return (
    <nav
      aria-label="Progress"
      className="bf-step-bar -mx-4 sm:-mx-6 -mt-6 mb-2 flex items-center justify-center gap-2 sm:gap-3 px-4 py-3"
      style={{ position: 'sticky', top: 0, zIndex: 1, background: '#f1e9df' }}
    >
      {STEPS.map((step, i) => {
        const isActive = step.num === active;
        const reached = step.num <= active;
        return (
          <span key={step.num} className="flex items-center gap-2 sm:gap-3">
            <span className={['flex items-center gap-2', step.num > active ? 'opacity-40' : ''].join(' ')}>
              <span
                aria-current={isActive ? 'step' : undefined}
                className={[
                  'flex algin-center justify-center place-items-center w-6 h-6 mb-0 rounded-full text-[11px] font-bold leading-none',
                  reached ? 'bg-teal text-white' : 'bg-soft-border text-white',
                ].join(' ')}
              >
                {step.num}
              </span>
              <span className="sm:inline text-[10px] font-semibold tracking-[0.07em] uppercase text-teal whitespace-nowrap">
                {step.label}
              </span>
            </span>
            {i < STEPS.length - 1 && (
              <span aria-hidden="true" className="text-warm-brown/40 text-lg leading-none">›</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
